export const MAX_IMPORT_SIZE_BYTES = 1 * 1024 * 1024;

export interface FileValidationResult {
  ok: boolean;
  reason?: string;
}

/**
 * Defence-in-depth client check; the server enforces the same rules.
 */
export function validateImportFile(file: File | null | undefined): FileValidationResult {
  if (!file) {
    return { ok: false, reason: "Please select a CSV file" };
  }
  if (file.size === 0) {
    return { ok: false, reason: "File is empty" };
  }
  if (file.size > MAX_IMPORT_SIZE_BYTES) {
    return { ok: false, reason: `File exceeds the ${MAX_IMPORT_SIZE_BYTES} byte limit (1 MB)` };
  }
  const lower = file.name.toLowerCase();
  if (!lower.endsWith(".csv")) {
    return { ok: false, reason: "File must have a .csv extension" };
  }
  return { ok: true };
}
